import React from 'react';

import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const StrategyPieChart = ({ strategyName, profit, loss }) => {
  const data = {
    labels: ['Profit', 'Loss'],
    datasets: [
      {
        data: [profit, Math.abs(loss)],
        backgroundColor: [
          'rgba(0, 200, 0, 0.7)', // green
          'rgba(200, 0, 0, 0.7)', // red
        ],
        borderColor: [
          'rgba(0, 200, 0, 1)',
          'rgba(200, 0, 0, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div style={{ width: 130, height: 130, margin: '0 auto', marginBottom : 10 }}>
      <Pie
        data={data}
        options={{
          plugins: {
            legend: { display: false, position: 'bottom' },
            datalabels: {
              color: '#fff',
              font: { weight: "bold", size: 16 },
              formatter: (value, context) => {
                // Show value with $ and no negative sign for loss
                if (context.dataIndex === 0) return `$${Number(value).toFixed(2)}`;
                return `-$${Number(value).toFixed(2)}`;
              },
              anchor: 'center',
              align: 'center',
            },
          },
        }}
      />
      <div style={{ textAlign: 'center', marginTop: 5, fontWeight: 'normal', fontSize : 11 }}>{strategyName}</div>
    </div>
  );
};

export default StrategyPieChart;
